import Columns from '../../grid/columns';

export default instance => {
  instance.attachEvent('onGridHeaderClick', (name, event) => {
    Columns.onGridHeaderClick(event);
  });
};
